import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { verifyProductAbbreviation } from '@uc/web/core';
import { of } from 'rxjs';

export const orderProspectusGuard = (route: ActivatedRouteSnapshot) => {
	const router = inject(Router);

	if (verifyProductAbbreviation(route.queryParams['product'])) {
		return of(true);
	} else {
		const qparams = { ...route.queryParams };
		delete qparams['product'];

		router.navigate(['/select'], {
			queryParams: qparams,
		});
		return of(false);
	}
};
